import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IDetailedHandoverQueue } from '../interfaces';
import { DetailedHandoverQueueMapper } from '../mappers';

export type IGetHandoverQueueRepoResponse = IRepoResponse<200, IDetailedHandoverQueue> | IRepoResponse<400 | 500, string>;

export type IGetHandoverQueueRepo = IRepo<[{ id: string | number }], IGetHandoverQueueRepoResponse>;

export const GetHandoverQueueRepoType = Symbol.for('GetHandoverQueueRepo');

@bind(GetHandoverQueueRepoType)
export class GetHandoverQueueRepo implements IGetHandoverQueueRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ id }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/handover/info', { handover_task_id: id }) });

      if (result.status === 200) {
        const data: IDetailedHandoverQueue = DetailedHandoverQueueMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else if (result.status === 400 || result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
